(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFieldDefinitionController', EventFieldDefinitionController);

    EventFieldDefinitionController.$inject = ['$state', '$uibModal', 'EventFieldDefinition', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'EventConfigurationAssistant'];

    function EventFieldDefinitionController($state, $uibModal, EventFieldDefinition, ParseLinks, AlertService, pagingParams, paginationConstants, EventConfigurationAssistant) {
        var vm = this;
        vm.openAssistant = function() { EventConfigurationAssistant.open('FIELDS', loadAll); };
        EventConfigurationAssistant.canUse('FIELDS').then(function(allowed) { vm.canUseAssistant = allowed; });

        vm.fieldDefinitions = [];
        vm.inclInactive = false;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.openVersions = openVersions;
        vm.dataTypeLabel = dataTypeLabel;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        loadAll();

        function loadAll() {
            EventFieldDefinition.query({
                inclInactive: vm.inclInactive,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fieldDefinitions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement du dictionnaire.');
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function openVersions(fieldDefinition) {
            $uibModal.open({
                templateUrl: 'app/business/event-field-definition/event-field-definition-versions.html',
                controller: 'EventFieldDefinitionVersionsController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return fieldDefinition;
                    }
                }
            });
        }

        function dataTypeLabel(dataType) {
            var labels = {
                text: 'Texte',
                integer: 'Entier',
                decimal: 'Décimal',
                boolean: 'Booléen',
                date: 'Date',
                datetime: 'Date/heure',
                list: 'Liste',
                satisfaction_smiley: 'Satisfaction smiley',
                ref_contrat: 'RefContrat'
            };
            return labels[dataType] || dataType;
        }
    }
})();
